import { HttpStatusCode } from "@angular/common/http";

/**
 * Backend error code returned (HTTP 409) when a device with the same serial
 * (`deviceId`) already exists in the program.
 */
export const DEVICE_ID_ALREADY_EXISTS = "DEVICE_ID_ALREADY_EXISTS";

interface ConflictErrorShape {
  status?: number;
  statusCode?: number;
  message?: string;
  error?: { message?: string } | string;
}

/**
 * Detects the "device serial already registered in this program" 409 conflict.
 *
 * The error reaching the effect differs by integration: the auth interceptors
 * (Shopify/Convercus) re-throw the unwrapped response body
 * (`{ statusCode: 409, message: "DEVICE_ID_ALREADY_EXISTS", ... }`), while in
 * standalone mode the raw `HttpErrorResponse` arrives (`status === 409`, body in
 * `error.error`). This handles both shapes.
 */
export const isDeviceConflictError = (error: unknown): boolean => {
  if (!error || typeof error !== "object") return false;

  const err = error as ConflictErrorShape;
  const status = err.status ?? err.statusCode;
  const nestedMessage = typeof err.error === "object" ? err.error?.message : undefined;

  return status === HttpStatusCode.Conflict || err.message === DEVICE_ID_ALREADY_EXISTS || nestedMessage === DEVICE_ID_ALREADY_EXISTS;
};
